import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ice_label_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = {
  login: (password) => axios.post(`${API}/admin/login`, { password }),
  verify: () => axios.get(`${API}/admin/verify`, { headers: authHeaders() }),
  listBookings: () => axios.get(`${API}/bookings`, { headers: authHeaders() }),
  createBooking: (data) => axios.post(`${API}/bookings`, data, { headers: authHeaders() }),
  updateBooking: (id, data) => axios.patch(`${API}/bookings/${id}`, data, { headers: authHeaders() }),
  deleteBooking: (id) => axios.delete(`${API}/bookings/${id}`, { headers: authHeaders() }),
};
